/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Failed_SendInputs */

const en_password_reset_failed_send = /** @type {(inputs: Password_Reset_Failed_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send reset email`)
};

const es_password_reset_failed_send = /** @type {(inputs: Password_Reset_Failed_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar el correo de restablecimiento`)
};

/**
* | output |
* | --- |
* | "Failed to send reset email" |
*
* @param {Password_Reset_Failed_SendInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_failed_send = /** @type {((inputs?: Password_Reset_Failed_SendInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Failed_SendInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_failed_send(inputs)
	return en_password_reset_failed_send(inputs)
});